export default "__VITE_ASSET__GzyEsxf5__"